import DropdownOptionGroup from "./DropdownOptionGroup";

export default class PdpDropdownGroupModal extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            title: this.props.data.DropDownName,
            originalIds: [],
            selectionCompleted: false,
            selectedPrice: 0,
            selectedId: 0
        };
       // this.props.originalIds = [];
        this.handleSingleChange = this.handleSingleChange.bind(this);
        this.props.data.DropDownEntries.map((item) => {
            if (item.selected === "true") {
                //this.state.title = item.label;
                this.state.selectionCompleted = true;
            }
            this.state.originalIds.push(item.value);
        });
    }
    handleSingleChange(item, originalIds, selectionCompleted) {
        let selectItem = {};
        let hierarchyData = [];
        selectItem.value = item.value;
        selectItem.label = item.label;
        selectItem.baseCal = item.BaseCalories;
        selectItem.price = item.CalcPrice;
        selectItem.componentDisplay = item.ComponentDisplay;
        selectItem.parentModifierId = this.props.parentModifierId || this.props.id || 0;
        selectItem.parentGroupId = this.props.id;
        selectItem.parentOptionGroupId = this.props.selectedoptionGroupId || this.props.parentModifierId || this.props.id || 0;
        let arr;
        if (this.props.fromModal == true) {
            arr = JSON.parse(JSON.stringify(this.props.getlocalMultiSelectIds()));
            console.log("clicked item -->", selectItem, arr);
        }

        console.log("this.props.fromModal --> ", this.props.fromModal)
        let data = {
            "id": item.value,
            "name": item.label
        }
        hierarchyData.push(data);

        console.log(this.state);
        // Remove the Previous amount
        if (this.state.selectedPrice != 0) {
            console.log("Remove the Previous selected dropdown amount -----> " + this.state.selectedPrice);
            this.props.updateTotalPrice(this.state.selectedPrice, "remove", this.state.selectedId);
            if (this.props.fromModal == true) {
                arr.splice(arr.indexOf(this.state.selectedId), 1);
            }

        }

        // Add the current amount
        console.log("Add the Current amount -----> " + item.Price);
        //this.props.updateTotalPrice(item.Price, "add", item.value);
        this.state.selectedPrice = item.Price;
        this.state.selectedId = item.value;
        if (this.props.fromModal == true) {
            arr.push(item.value);
            this.props.setlocalMultiSelectIds(arr);
        }
        this.props.holdTempSelectedIds('single', selectItem, originalIds, selectionCompleted);


    }

    render() {
        const { title, originalIds, selectionCompleted } = this.state
        return (
            <div className="maxOneDropdown App">
                <DropdownOptionGroup items={this.props.data.DropDownEntries}
                    title={title} selectionCompleted={selectionCompleted}
                    handleSelectBox={(item, selectionCompleted) => this.handleSingleChange(item, originalIds, selectionCompleted)}
                    id={this.props.id} reqdStatus={this.props.reqdStatus} selectedModifiers={this.props.selectedModifiers}
                />

            </div>
        );
    }
}
